// extracted by mini-css-extract-plugin
export default {"button":"DateRangePicker_button__sRBXl","placeholder":"DateRangePicker_placeholder__FjJNO"};